import { unref as _unref, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/index/lightPoint.png';
import _imports_1 from '@/assets/img/index/agentTalk.svg';
import _imports_2 from '@/assets/img/index/dateSeries.svg';
import _imports_3 from '@/assets/img/index/dateUpdate.svg';
import _imports_4 from '@/assets/img/index/openCollaboration.svg';
import _imports_5 from '@/assets/img/index/safeAgentTo.svg';
const _withScopeId = n => (_pushScopeId("data-v-8b2f24ee"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-page"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content-top"
}, [/*#__PURE__*/_createElementVNode("img", {
  height: "31",
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("p", null, "集成了丰富安全知识库的综合性智能安全专家")])]), /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content-top"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("p", null, "涵盖四大知识库")]), /*#__PURE__*/_createElementVNode("div", {
  class: "con-cell"
}, [/*#__PURE__*/_createElementVNode("span", null, "CVE漏洞信息"), /*#__PURE__*/_createElementVNode("span", null, "CWE软件缺陷"), /*#__PURE__*/_createElementVNode("span", null, "安全标准"), /*#__PURE__*/_createElementVNode("span", null, "最新安全研究成果")])]), /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content-top"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("p", null, "提供多元化安全服务")]), /*#__PURE__*/_createElementVNode("div", {
  class: "con-cell"
}, [/*#__PURE__*/_createElementVNode("span", null, "安全知识问答"), /*#__PURE__*/_createElementVNode("span", null, "安全教育培训"), /*#__PURE__*/_createElementVNode("span", null, "辅助编写安全文档"), /*#__PURE__*/_createElementVNode("span", null, "解读安全论文研究")])])], -1));
const _hoisted_2 = {
  class: "back-agent"
};
const _hoisted_3 = {
  alt: ""
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "con-detail"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "detail-cell"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "img-icon",
  src: _imports_1,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" 智能的推理与对话 ")]), /*#__PURE__*/_createElementVNode("p", {
  class: "detail-cell"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "img-icon",
  src: _imports_2,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" 丰富的多场景数据集 ")]), /*#__PURE__*/_createElementVNode("p", {
  class: "detail-cell"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "img-icon",
  src: _imports_3,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" 持续的数据更新 ")]), /*#__PURE__*/_createElementVNode("p", {
  class: "detail-cell"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "img-icon",
  src: _imports_4,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" 开放的协作与集成能力 ")]), /*#__PURE__*/_createElementVNode("p", {
  class: "detail-cell"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "img-icon",
  src: _imports_5,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" 定制的智能安全服务 ")])], -1));
import agentCom from './agentCom.vue';
import { ref } from 'vue';
export default {
  __name: 'safeAgentCom',
  setup(__props, {
    expose: __expose
  }) {
    let pageActive = ref(false);
    __expose({
      pageActive
    });
    return (_ctx, _cache) => {
      const _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(_unref(pageActive) ? 'safe-agent active' : 'safe-agent')
      }, [_createVNode(agentCom, {
        showBotton: true,
        title: '安全知识类智能体',
        pageUrl: '/safetyKnowledgeProduct.html'
      }, {
        left: _withCtx(() => [_hoisted_1]),
        right: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [[_directive_lazy, require('@/assets/img/index/agentSafeAgent.svg')]])])]),
        bottom: _withCtx(() => [_hoisted_4]),
        _: 1
      })], 2);
    };
  }
};